const mediaplayertestimonial = {
  defaultOpened: 0,
  items: [
    {
      title: "Product Manager, Luxembourg",
      description:
        "The team worked well with the client, communicating clearly through virtual meetings, email, and a messaging app. They went the extra mile to ensure the project's success.",
    },
    {
      title: "Founder, Texas, United States",
      description:
        'The team was detail-oriented, timely, hardworking, and strategic. They communicated well, proposed additional options, and thoroughly went through the process to deliver the best possible solution.',
    },
    {
      title: "Tom, Pyng, Bristol",
      description:
        "All the developers that worked on our project have been excellent in all aspects. Their technical ability has far surpassed our expectations in a range of key skills including react native mobile development and AWS cloud.",
    },
    {
      title: "CTO, Pyng",
      description:
        "The communication from the team, both written and verbal was very good and was much better than other developers that I have worked with before, even including at some of the worlds biggest banks.",
    },
  ],
};

const textProps = {
  heading2: {
    color: "lightBlue",
    subtitle: "Your Success, Our Commitment",
    title: "What Our Clients Say",
    description:
      "We take pride in delivering exceptional service and creating meaningful impacts for our clients. Read what our clients have to say about their experiences with us:",
    alignment: "left",
  },
  mediaplayer: {
    ...mediaplayertestimonial,
  },
};
export default textProps;
